import React from "react"
import "./Residency.css"

const Residency = () => {
  return (
    <div>
      <div className="swissresidency">
        <div className="swissresidency-top" data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine">
          <img src="./DowntownPhotos/Residency/residency.png" alt="building" />
        </div>
        <div className="swissresidency-bottom" data-aos="fade-left"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine">
          <h3>WELCOME TO <br /> SWISS RESIDENCES</h3>
          <p>
            The Swiss by Avenue One is planned as a future premium residential project refined Swiss
            living standards, modern design discipline, and international hospitality-led residential
            concepts.
            Positioned as the first Swiss residences concept in Bahria Town Lahore, Pakistan, The Swiss
            is being planned for buyers who value exclusivity, design clarity, privacy, and a refined
            residential environment.

          </p>
        </div>
      </div>
    </div>
  )
}

export default Residency